import React from "react";
import "./PLVCard.css";
import UiButton from "../ui/UiButton";
import confs from "../../configurations";
import useTranslations from "../Translations/useTranslations";
import { ICON } from "../../assets";
import UiIcon from "../ui/UiIcon";
const { URL_GED } = confs;

function PLVCard({ article, addInCart, PLV_CART, inCart }) {
  const trl = useTranslations();
  const _article =
    PLV_CART && PLV_CART.find((art) => art.article.CODART === article.CODART);
  let qte_commande = 0;
  if (_article) {
    qte_commande = _article.qte_commande;
  }
  const isInCart = qte_commande > 0;

  const onlyOneBuy = 1;
  const maxBuy = null; //  if you want to limit max buy for a product, set a number here;

  function handleAdd() {
    if (
      article.TESTEUR_ou_PLV.startsWith("TES") &&
      qte_commande === onlyOneBuy
    ) {
      return;
    }
    if (maxBuy && qte_commande >= maxBuy) {
      return;
    }
    addInCart(article, qte_commande + 1);
  }

  function handleRemove() {
    if (qte_commande - 1 < 0) return;
    addInCart(article, qte_commande - 1);
  }

  function handleEmty(e) {
    e.preventDefault();
    e.stopPropagation();
    if (qte_commande === 0) return;
    addInCart(article, 0);
  }

  function renderAddMessage() {
    return (
      <React.Fragment>
        <div className="card-added-message">Ajouté !</div>
      </React.Fragment>
    );
  }

  function renderAddRemoveButtons() {
    const buttonStyle = {
      padding: "4px 0",
    };
    return (
      <React.Fragment>
        <div className="add-remove-buttons">
          <UiButton
            content={
              <UiIcon icon={ICON.minusIcon} alt="minus-icon" size="lg" />
            }
            style={buttonStyle}
            onClick={handleRemove}
          />
          <div className="product-quantity" style={{ fontSize: "15px" }}>
            {qte_commande}
          </div>
          <UiButton
            content={<UiIcon icon={ICON.plusIcon} alt="plus-icon" size="lg" />}
            style={buttonStyle}
            onClick={handleAdd}
          />
        </div>
      </React.Fragment>
    );
  }

  function renderSingleBuyButton() {
    if (qte_commande < onlyOneBuy) {
      return (
        <React.Fragment>
          <UiButton content={"Ajouter"} onClick={handleAdd} />
        </React.Fragment>
      );
    } else {
      return renderAddMessage();
    }
  }

  function renderMaxBuyButton() {
    if (maxBuy && qte_commande >= maxBuy) {
      return renderAddMessage();
    }
    return renderAddRemoveButtons();
  }

  function renderActionButton() {
    if (article.TESTEUR_ou_PLV.startsWith("TES")) {
      return renderSingleBuyButton();
    } else if (maxBuy) {
      return renderMaxBuyButton();
    } else {
      return renderAddRemoveButtons();
    }
  }

  function renderProductImage() {
    const backgroundImageUrl = `url(${URL_GED}/Articles/${article.CODART}/${article.CODART}-e.jpg)`;
    return (
      <React.Fragment>
        <div
          className="product-image"
          style={{ backgroundImage: backgroundImageUrl }}
        ></div>
      </React.Fragment>
    );
  }

  function renderProductDescription() {
    const getRecommendationDisplay = () => {
      if (article.why_recommandation) {
        return (
          <div className="product-recommandation">
            {trl.message("CompleteOrderPage.Product.recommandation", {
              recommendedBy: article.why_recommandation,
            })}
          </div>
        );
      }
    };

    const productLabel = `${trl.data.message(
      "ART",
      "CODART",
      article.CODART,
      "LIBART"
    )}  (${article.CODART})`;

    return (
      <React.Fragment>
        <div className="product-description">
          <div className="product-label">{productLabel}</div>
          {getRecommendationDisplay()}
        </div>
      </React.Fragment>
    );
  }

  function renderCardHeader() {
    if (isInCart) {
      return (
        <React.Fragment>
          <div className="card-header-container">
            <span className="product-quantity">{qte_commande}</span>
            <UiIcon
              className="trash-icon-button"
              size="md"
              alt="trash-icon"
              icon={ICON.trashIcon}
              onClick={handleEmty}
            />
          </div>
        </React.Fragment>
      );
    }
  }

  return (
    <React.Fragment>
      <div className={`card-frame  ${isInCart ? "add-card" : ""} `}>
        <div className="card-frame-header"> {renderCardHeader()}</div>
        <div className="card-frame-product-info">
          {renderProductImage()} {renderProductDescription()}
        </div>
        <div className="card-frame-controls">
          <div className="card-product-price">{article.PUB}{" "}€</div>
          <div className="card-product-controls">{renderActionButton()}</div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default PLVCard;
